/**
 * Chart-facing prompt name: basename without a file extension.
 * Short names without path segments are unchanged.
 */
export function formatReleasePromptForDisplay(prompt: string): string {
  const segment = prompt.includes('/') ? (prompt.split('/').pop() ?? prompt) : prompt;
  if (segment.endsWith('.md')) {
    return segment.slice(0, -3);
  }
  return segment;
}
